'use client';

import MDEditor from '@uiw/react-md-editor';
import { cn } from '@/lib/utils';

interface MarkdownContentProps {
  content: string;
  className?: string;
}

/**
 * Markdown content renderer using @uiw/react-md-editor
 */
export function MarkdownContent({ content, className }: MarkdownContentProps) {
  return (
    <div className={cn('text-muted-foreground', className)} data-color-mode="light">
      <MDEditor.Markdown
        source={content}
        style={{
          backgroundColor: 'transparent',
          color: 'inherit',
          fontSize: 'inherit',
          lineHeight: '1.75',
        }}
      />
    </div>
  );
}
